import React from "react";
import { Platform, useWindowDimensions } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { Dialog, VisuallyHidden, YStack, useMedia } from "tamagui";

const MAX_WIDTH = 945;
const NATIVE_HEADER_GAP = 32;

interface SearchModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children?: React.ReactNode;
}

export function SearchModal({ open, onOpenChange, children }: SearchModalProps) {
  const isWeb = Platform.OS === "web";
  const { width, height: screenHeight } = useWindowDimensions();
  const insets = useSafeAreaInsets();
  const media = useMedia();
  const headerRowHeight = media.gtMd ? 85 : media.gtSm ? 72 : 64;
  const modalTop = isWeb ? 90 : insets.top + headerRowHeight + NATIVE_HEADER_GAP;
  const modalHeight = isWeb
    ? undefined
    : Math.min(720, Math.max(screenHeight - modalTop - 90, 360));

  return (
    <Dialog modal open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal zIndex={200}>
        <Dialog.Overlay
          key="overlay"
          animation="quick"
          backgroundColor="rgba(0,0,0,0.35)"
          enterStyle={{ opacity: 0 }}
          exitStyle={{ opacity: 0 }}
          onPress={() => onOpenChange(false)}
          zIndex={200}
        />
        <Dialog.Content
          key="content"
          animateOnly={["transform", "opacity"]}
          animation={[
            "quick",
            { opacity: { overshootClamping: true } },
          ]}
          enterStyle={{ y: -10, opacity: 0 }}
          exitStyle={{ y: -10, opacity: 0 }}
          padding="$0"
          backgroundColor="white"
          borderRadius={8}
          position="absolute"
          top={modalTop}
          alignSelf="center"
          width={isWeb ? "calc(100% - 64px)" : Math.min(MAX_WIDTH, width - 64)}
          maxWidth={MAX_WIDTH}
          maxHeight={isWeb ? "calc(100vh - 180px)" : modalHeight}
          minHeight={360}
          height={modalHeight}
          overflow="hidden"
          onPress={(e) => e.stopPropagation()}
          zIndex={200}
          style={{
            borderRadius: 8,
            overflow: "hidden",
            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.10), 0 0 4px 0 rgba(0,0,0,0.08)",
          }}
        >
          <VisuallyHidden>
            <Dialog.Title>Search</Dialog.Title>
          </VisuallyHidden>
          <YStack f={1} minHeight={0} w="100%">
            {children}
          </YStack>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
}
